export const mbLoginRegisterPage = {
  mbLogin: {
    singIn: 'Sign in',
    continueAsGuest: 'or continue as a guest',
    loginBtn: 'Login',
    email: 'E-mail',
    password: 'Password',
    forgotYourPassword: 'Forgot Your Password?'
  },
  mbRegister: {
    registerNow: 'Register Now',
    dontHaveAnAccount: 'Don\'t have an account yet?',
    registerHereAndProfit: 'Register here and profit from multiple advantages.',
    oneClickReorders: 'One-click reorders',
    orderTracking: 'Order tracking',
    favoriteList: 'Favorite list',
    saveCarts: 'Save carts',
    clickRegisterNowMsg: 'By clicking on „Register now" I confirm, that this page is for business customers only.',
    next: 'Next'
  }
}
